/** Map requested filter values to stored strings using trim + case-insensitive equality. */
export function expandCaseInsensitiveMatches(
  stored: Array<string | null | undefined>,
  requested: string[]
): string[] {
  const wanted = new Set(
    requested.map((value) => value.trim().toLowerCase()).filter(Boolean)
  );
  if (!wanted.size) return [];

  const matches = new Set<string>();
  for (const value of stored) {
    if (value && wanted.has(value.trim().toLowerCase())) {
      matches.add(value);
    }
  }
  return [...matches];
}

export function emptyParticipantPage<T = unknown>(page: number) {
  return {
    data: [] as T[],
    pagination: {
      total: 0,
      hasNextPage: false,
      hasPreviousPage: page > 1,
      currentPage: page,
    },
  };
}

export function toOidList(ids: string[]) {
  return ids.filter(Boolean).map((id) => ({ $oid: id }));
}
